import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Grid, IconButton } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5)
}))

export const StyledGrid = styled(Grid)({
  maxWidth: "100%",
  margin: "0",
  width: "100%",
  position: "absolute",
  top: 66,
  zIndex: 999,
  paddingLeft: 15,
  "@media (max-width: 480px)": {
    paddingLeft: "8px",
    paddingRight: "8px"
  }
})

export const StyledGridButton = styled(Grid)({
  maxWidth: "100%",
  margin: "0",
  width: "100%",
  position: "absolute",
  top: 86,
  zIndex: 999,
  paddingLeft: 15,
  "@media (max-width: 480px)": {
    paddingLeft: "8px",
    paddingRight: "8px"
  }
})

export const StyledDateGrid = styled(Grid)(({ theme }) => ({
  background: (theme.palette as any).foreground.inverted,
  padding: "16px",
  minHeight: "55px",
  boxShadow: "4px 4px 10px 8px rgba(0, 0, 0, 0.09)",
  borderRadius: "3px",
  "& input": {},
  "@media (max-width: 480px)": {
    marginTop: "48px"
  }
}))

export const StyledBlueGrid = styled(Grid)(({ theme }) => ({
  marginLeft: "16px",
  background: (theme.palette as any).primary[700],
  color: (theme.palette as any).secondary.main,
  padding: "5px 10px",
  minHeight: "55px",
  boxShadow: "4px 4px 10px 8px rgba(0, 0, 0, 0.09)",
  borderRadius: "3px",
  "@media (max-width: 480px)": {
    marginLeft: "0px",
    marginTop: "8px",
    minHeight: "40px"
  }
}))

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  cursor: "pointer",
  paddingLeft: "8px"
}))

export const StyledDeviceListGrid = styled(Grid)(({ theme }) => ({
  position: "absolute",
  right: 0,
  paddingRight: "16px",
}))

export const StyledToggleFontAwesomeIcon = styled(FontAwesomeIcon)(({ theme }) => ({
  marginLeft: "8px",
  color: "var(--secondary)"
}))
